import { authGet, authPost } from '../http_client.js';
import type { DailyCardClaimDto, FirstStepsClaimDto, HappyFallBuyDto, HappyFallDropDto, HappyFallStateDto, LevelBoxOpenDto, RewardWidgetsStateDto, WheelSpinDto } from '../dto/reward_widgets.dto.js';

export function getRewardWidgets(): Promise<RewardWidgetsStateDto>
{
  return authGet<RewardWidgetsStateDto>( 'api/player/me/reward-widgets' );
}

export function claimDailyCard( card_index: number ): Promise<DailyCardClaimDto>
{
  return authPost<DailyCardClaimDto>( 'api/player/me/reward-widgets/daily-cards/claim', { card_index } );
}

export function spinWheel(): Promise<WheelSpinDto>
{
  return authPost<WheelSpinDto>( 'api/player/me/reward-widgets/wheel/spin' );
}

export function dropHappyFall(): Promise<HappyFallDropDto>
{
  return authPost<HappyFallDropDto>( 'api/player/me/reward-widgets/happy-fall/drop' );
}

export function buyHappyFallBalls(): Promise<HappyFallBuyDto>
{
  return authPost<HappyFallBuyDto>( 'api/player/me/reward-widgets/happy-fall/buy' );
}

export function debugAddHappyFallBall(): Promise<{ happy_fall: HappyFallStateDto }>
{
  return authPost<{ happy_fall: HappyFallStateDto }>( 'api/player/me/debug/reward-widgets/happy-fall/add-ball' );
}

export function claimFirstSteps(): Promise<FirstStepsClaimDto>
{
  return authPost<FirstStepsClaimDto>( 'api/player/me/reward-widgets/first-steps/claim' );
}

export function openLevelBox(): Promise<LevelBoxOpenDto>
{
  return authPost<LevelBoxOpenDto>( 'api/player/me/reward-widgets/level-box/open' );
}
